<template>
   <div class="gens-cancerrealtime">
       <!-- <div class="img-ss">
            <img class="gens-img" src="../../assets/images/headerimg/Header_1920x380_cancer-cancer-monitoring.jpg" />
             <h1 class="gens-title">{{$t('ContractText.CancerReal')}}</h1>
       </div> -->
       <banner>
            <img src="../../assets/images/headerimg/Header_1920x380_cancer-cancer-monitoring.jpg"/>
            <div slot="title">{{$t('ContractText.CancerReal')}}</div>
        </banner>
       <div class="gens_header_tip">
           <div class="tip_red">{{$t('Cancerrealtime.CancerReal_one')}}</div>
           <div class="tip_white">{{$t('Cancerrealtime.CancerReal_two')}}</div>
       </div>

        <div class="gens_result">
               <div class="gens_result_info">
                   <div class="gens_result_info_tip">
                       <div class="result_text">{{$t('Cancerrealtime.CancerReal_three')}}</div>
                       <div class="result_line"></div>
                   </div>
                  <div class="gens_content_first">
                      <div class="gens_content_first_left">
                         <div>{{$t('Cancerrealtime.CancerReal_four')}}</div>

                         <div>{{$t('Cancerrealtime.CancerReal_five')}}</div>
                      </div>
                      <div class="gens_content_first_right">
                          <div class="gens_content_first_right_img">
                               <img src="../../assets/images/cancerrealtime/ctDNA-5.jpg" />
                          </div>
                      </div>
                  </div>
               </div>
        </div>

        <div class="gens_three_img">
            <div class="gens_three_img_content">
                <div class="gens_three_img_content_d">
                    <div class="gens_three_img_content_tip">{{$t('Cancerrealtime.CancerReal_six')}}</div>
                    <div class="three_imgs">
                        <img src="../../assets/images/cancerrealtime/cancer_icon-38.png" />
                    </div>
                </div>
            </div>
        </div>

        <div class="gens_result science_top"  >
            <div class="gens_result_info">
                <div class="gens_result_info_tip">
                    <div class="result_text">{{$t('Cancerrealtime.CancerReal_seven')}}<sup style="font-size:.5em;vertical-align:super">{{$t('Cancerrealtime.CancerReal_fuhao')}}</sup>{{$t('Cancerrealtime.CancerReal_f')}}</div>
                    <div class="result_line"></div>
                </div>
                <div class="gens_transparent_content_info">
                   <span class="mytick"></span> 
                   <span class="tick_text">{{$t('Cancerrealtime.CancerReal_eight')}}</span>
                </div>
                <div class="gens_transparent_content_info">
                   <span class="mytick"></span> 
                   <span class="tick_text">{{$t('Cancerrealtime.CancerReal_nine')}}</span>
                </div>
                <div class="gens_transparent_content_info">
                   <span class="mytick"></span> 
                   <span class="tick_text">{{$t('Cancerrealtime.CancerReal_ten')}}</span>
                </div>
                
                <div class="gens_result_science" >
                       <div class="science_item science_item_special science_item_special_std" id="science_one">
                           <div class="science_item_img" >
                               <img class="img_science img_science_specials"  src="../../assets/images/cancerrealtime/cancer_icon-46.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <div class="abstract_tip ab_special">{{$t('Cancerrealtime.CancerReal_eleven')}}</div>
                               <div class="abstract_content ab_special">{{$t('Cancerrealtime.CancerReal_twelve')}}</div>
                           </div>
                       </div>
                       <div class="science_item science_item_special science_item_special_std" id="science_two">
                           <div class="science_item_img">
                               <img class="img_science img_science_specials"  src="../../assets/images/cancerrealtime/cancer_icon-47.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <div class="abstract_tip ab_special">{{$t('Cancerrealtime.CancerReal_threeteen')}}</div>
                               <div class="abstract_content ab_special">{{$t('Cancerrealtime.CancerReal_fourteen')}}</div>
                           </div>
                       </div>
                       <div class="science_item science_item_special science_item_special_std" id="science_three">
                           <div class="science_item_img">
                               <img class="img_science img_science_specials"  src="../../assets/images/cancerrealtime/cancer_icon-48.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <div class="abstract_tip ab_special">{{$t('Cancerrealtime.CancerReal_fiveteen')}}</div>
                               <div class="abstract_content ab_special">{{$t('Cancerrealtime.CancerReal_sixteen')}}</div>
                           </div>
                       </div>
                       <div class="science_item science_item_special science_item_special_std" id="science_four">
                           <div class="science_item_img">
                               <img class="img_science img_science_specials"  src="../../assets/images/cancerrealtime/cancer_icon-49.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <div class="abstract_tip ab_special">{{$t('Cancerrealtime.CancerReal_seventeen')}}</div>
                               <div class="abstract_content ab_special">{{$t('Cancerrealtime.CancerReal_eighteen')}}</div>
                           </div>
                       </div>
                       
                   </div>
            </div>
         </div>
        

         <div class="gens_result special_result">
            <div class="gens_result_info">
                <div class="gens_result_info_tip">
                    <div class="result_text">{{$t('Cancerrealtime.CancerReal_nineteen')}}</div>
                    <div class="result_line"></div>
                </div>
            </div>
            <div class="gens_list">
                <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/cancerrealtime/cancer_icon-23.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('Cancerrealtime.CancerReal_twenty')}}</div>
                            <div class="gens_list_item_abstract">{{$t('Cancerrealtime.CancerReal_twenty_one')}}</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/cancerrealtime/cancer_icon-25.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('Cancerrealtime.CancerReal_twenty_two')}}</div>
                            <div class="gens_list_item_abstract">{{$t('Cancerrealtime.CancerReal_twenty_three')}}</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/cancerrealtime/cancer_icon-27.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('Cancerrealtime.CancerReal_twenty_four')}}</div>
                            <div class="gens_list_item_abstract">{{$t('Cancerrealtime.CancerReal_twenty_five')}}</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/cancerrealtime/cancer_icon-29.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('Cancerrealtime.CancerReal_twenty_six')}}</div>
                            <div class="gens_list_item_abstract">{{$t('Cancerrealtime.CancerReal_twenty_seven')}}</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/cancerrealtime/cancer_icon-31.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('Cancerrealtime.CancerReal_twenty_eight')}}</div>
                            <div class="gens_list_item_abstract">{{$t('Cancerrealtime.CancerReal_twenty_nine')}}</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/cancerrealtime/cancer_icon-33.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('Cancerrealtime.CancerReal_thirty')}}</div>
                            <div class="gens_list_item_abstract">{{$t('Cancerrealtime.CancerReal_thirty_one')}}</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/cancerrealtime/cancer_icon-35.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('Cancerrealtime.CancerReal_thirty_two')}}</div>
                            <div class="gens_list_item_abstract">{{$t('Cancerrealtime.CancerReal_thirty_three')}}</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/cancerrealtime/cancer_icon-24.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('Cancerrealtime.CancerReal_thirty_four')}}</div>
                            <div class="gens_list_item_abstract">{{$t('Cancerrealtime.CancerReal_thirty_five')}}</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/cancerrealtime/cancer_icon-26.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('Cancerrealtime.CancerReal_thirty_six')}}</div>
                            <div class="gens_list_item_abstract">{{$t('Cancerrealtime.CancerReal_thirty_eight')}}</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/cancerrealtime/cancer_icon-28.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('Cancerrealtime.CancerReal_thirty_nine')}}</div>
                            <div class="gens_list_item_abstract">{{$t('Cancerrealtime.CancerReal_fourty')}}</div>
                        </div>
                    </div>
                </div>
                <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/cancerrealtime/cancer_icon-30.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('Cancerrealtime.CancerReal_fourty_one')}}</div>
                            <div class="gens_list_item_abstract">{{$t('Cancerrealtime.CancerReal_fourty_two')}}</div>
                        </div>
                    </div>
                </div>
                <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/cancerrealtime/cancer_icon-32.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('Cancerrealtime.CancerReal_fourty_four')}}</div>
                            <div class="gens_list_item_abstract">{{$t('Cancerrealtime.CancerReal_fourty_five')}}</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/cancerrealtime/cancer_icon-34.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('Cancerrealtime.CancerReal_fourty_six')}}</div>
                            <div class="gens_list_item_abstract">{{$t('Cancerrealtime.CancerReal_fourty_seven')}}</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/cancerrealtime/cancer_icon-36.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('Cancerrealtime.CancerReal_fourty_eight')}}</div>
                            <div class="gens_list_item_abstract">{{$t('Cancerrealtime.CancerReal_fourty_nine')}}</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item"></div>
                 <div class="gens_list_item"></div>
            </div>
            <div class="gens_result_info">
                    <ul>
                        <li style="line-height:27px;font-weight:400;font-size:16px;">{{$t('Cancerrealtime.CancerReal_fifty')}}<sup>TM</sup>{{$t('Cancerrealtime.CancerReal_fifty_one')}}</li>
                        <li style="line-height:27px;font-weight:400;font-size:16px;">{{$t('Cancerrealtime.CancerReal_fifty_two')}}</li>
                    </ul>

            </div>
         </div>



        <div class="gens_result ">
            <div class="gens_result_info">
                <div class="gens_result_info_tip">
                    <div class="result_text">{{$t('Cancerrealtime.CancerReal_fifty_three')}}<sup style="font-size:.5em;vertical-align:super">{{$t('Cancerrealtime.CancerReal_fuhao')}}</sup>{{$t('Cancerrealtime.CancerReal_canhelp')}}</div>
                    <div class="result_line"></div>
                </div>
                <div class="gens_result_science gens_result_science_special">
                       <div class="science_item science_item_special science_item_special_std">
                           <div class="science_item_img">
                               <img class="img_science" src="../../assets/images/cancerrealtime/cancer_icon-01.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <div class="abstract_tip abstract_tip_special">{{$t('Cancerrealtime.CancerReal_fifty_four')}}</div>
                               <hr class="abstract_line">
                               <div class="abstract_content">{{$t('Cancerrealtime.CancerReal_fifty_five')}}<span class="number">1。</span></div>
                               <div class="abstract_content_one"><ul><li> {{$t('Cancerrealtime.CancerReal_fifty_six')}}</li></ul></div>
                           </div>
                       </div>
                       <div class="science_item science_item_special science_item_special_std">
                           <div class="science_item_img">
                               <img class="img_science" src="../../assets/images/cancerrealtime/cancer_icon-02.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <div class="abstract_tip abstract_tip_special">{{$t('Cancerrealtime.CancerReal_fifty_seven')}}</div>
                               <hr class="abstract_line">
                               <div class="abstract_content">{{$t('Cancerrealtime.CancerReal_fifty_eight')}}<span class="number">2。</span></div>
                               <div class="abstract_content_one">
                                   <ul>
                                       <li> {{$t('Cancerrealtime.CancerReal_fifty_nine')}}</li>
                                       <li> {{$t('Cancerrealtime.CancerReal_sixty')}}</li>

                                   </ul>
                                </div>
                           </div>
                       </div>
                       <div class="science_item science_item_special science_item_special_std">
                           <div class="science_item_img">
                               <img class="img_science" src="../../assets/images/cancerrealtime/cancer_icon-03.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <div class="abstract_tip abstract_tip_special"> {{$t('Cancerrealtime.CancerReal_sixty_one')}}</div>
                               <hr class="abstract_line">
                               <div class="abstract_content"> {{$t('Cancerrealtime.CancerReal_sixty_two')}}<span class="number">3。</span></div>
                               <div class="abstract_content_one"><ul><li>  {{$t('Cancerrealtime.CancerReal_sixty_three')}}</li></ul></div>
                           </div>
                       </div>
                       <div class="science_item science_item_special science_item_special_std">
                           <div class="science_item_img">
                               <img class="img_science" src="../../assets/images/cancerrealtime/cancer_icon-04.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <div class="abstract_tip abstract_tip_special"> {{$t('Cancerrealtime.CancerReal_sixty_four')}}</div>
                               <hr class="abstract_line">
                               <div class="abstract_content"> {{$t('Cancerrealtime.CancerReal_sixty_five')}}<span class="number">1。</span></div>
                               <div class="abstract_content_one"><ul><li>  {{$t('Cancerrealtime.CancerReal_sixty_six')}}</li></ul></div>
                           </div>
                       </div>
                </div>
            </div>
         </div>

        <div class="gens_result gens_result_people people_tops" >
            <div class="gens_result_info" >
                <div class="gens_result_info_tip">
                    <div class="result_text">{{$t('Cancerrealtime.CancerReal_sixty_seven')}}</div>
                    <div class="result_line"></div>
                </div>
                <div class="gens_result_info_imgs">
                    <div class="gens_result_info_left_img">
                        <div class="info_left_img_item ">
                            <img src="../../assets/images/cancerrealtime/cancer_icon-39.png" />
                        </div>
                        <div class="info_left_img_item " id="one">
                            <img src="../../assets/images/cancerrealtime/cancer_icon-40.png" />
                        </div>
                        <div class="info_left_img_item " id="two">
                            <img src="../../assets/images/cancerrealtime/cancer_icon-41.png" />
                        </div>
                        <div class="info_left_img_item" id=three>
                            <img src="../../assets/images/cancerrealtime/cancer_icon-42.png" />
                        </div>
                    </div>
                    <div class="gens_result_info_right_img">
                        <div class="info_right_img_info">
                            <div class="right_imgs"> 
                                <img src="../../assets/images/cancerrealtime/cancer_icon-43.png" />
                            </div>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="gens_last_bottom">
            <div class="gens_last_bottom_content">
                <div class="gens_last_bottom_content_tip">{{$t('Cancerrealtime.CancerReal_sixty_eight')}}</div>
                <div class="gens_last_bottom_content_tip_line"></div>
                <div class="gens_last_bottom_content_descript">
                    <i class="icon iconfont iconyinhao yinhao"></i>
                    <div class="contents">
                        <div class="contents_tip">{{$t('Cancerrealtime.CancerReal_sixty_nine')}}<sup style="font-size:.5em;vertical-align:super">®</sup>{{$t('Cancerrealtime.CancerReal_sixty_nine_end')}}</div>
                        <div class="contents_cont">{{$t('Cancerrealtime.CancerReal_seventy')}}</div>
                    </div>
                </div>
                <div class="gens_last_bottom_content_descript">
                    <i class="icon iconfont iconyinhao yinhao"></i>
                    <div class="contents">
                        <div class="contents_tip">{{$t('Cancerrealtime.CancerReal_seventy_one')}}</div>
                        <div class="contents_cont">{{$t('Cancerrealtime.CancerReal_seventy_two')}}</div>
                    </div>
                </div>
                 <div class="gens_last_bottom_content_descript">
                    <i class="icon iconfont iconyinhao yinhao"></i>
                    <div class="contents">
                        <div class="contents_tip">{{$t('Cancerrealtime.CancerReal_seventy_three')}}</div>
                        <div class="contents_cont">{{$t('Cancerrealtime.CancerReal_seventy_four')}}</div>
                    </div>
                </div>
                <div class="bottom_document_tip">{{$t('Cancerrealtime.CancerReal_seventy_five')}}</div>
                <div class="bottom_document_cont">1. Siravegna G, Mussolin B, Buscarino M, et al. (2015). Clonal evolution and resistance to EGFR blockade in the blood of colorectal cancer patients. Nature Medicine 21(7):795–801.</div>
                <div class="bottom_document_cont">2. Gray ES, Rizos H, Reid AL, et al. (2015). Circulating tumor DNA to monitor treatment response and detect acquired resistance in patients with metastatic melanoma. Oncotarget 6(39):42008-42018.</div>
                <div class="bottom_document_cont bottom_document_cont_last">3. Chaudhuri AA, Chabon JJ, Lovejoy AF, et al. (2017). Early detection of molecular residual disease in localized lung cancer by circulating tumor DNA profiling. Cancer Discovery 7(12):1394–1403.</div>
            </div>
        </div>
   
   </div>
</template>
<script>
import banner from '@/components/banner'

export default {
    data(){
        return{
          
        }
    },
    
    components: {
      banner,
     
    },
    mounted(){
        $(window).scroll(function(){ //滚动某位置 动画特效
            var box = document.querySelector(".gens_content_first_right_img");
            if( box!=null&&$(window).scrollTop()>(box.offsetTop - box.offsetHeight)){
                $('.gens_content_first_right_img').addClass('opacity');//这里840代表要动画的元素离最顶层的距离，console.log一下就知道了。
                $('.gens_content_first_right_img').addClass('rightturnleft');
            }
            // var box_one= document.querySelector(".img_img_left");
            // if($(window).scrollTop() > (box_one.offsetTop - box_one.offsetHeight)){
            //     $('.img_img_right').addClass('opacity');
            //     $('.text_left_content').addClass('opacity');
            //     $('.text_right_content').addClass('opacity');
            //     $('.img_img_left').addClass('opacity');
                
            // }
            // var box_two= document.querySelector(".science_item_img");
            // if($(window).scrollTop() > (box_two.offsetTop - box_two.offsetHeight)){
            //     $('.science_item_img').addClass('opacity');
            // }
            var box_three= document.querySelector(".people_tops");
            if( box_three!=null&&$(window).scrollTop() > (box_three.offsetTop - box_three.offsetHeight)){
                $('.info_left_img_item').addClass('opacity');
                $('#one').addClass('one_transfer');
                $('#two').addClass('two_transfer');
                $('#three').addClass('three_transfer');


                $('.info_right_img_info').addClass('opacity');
                $('.info_right_img_info').addClass('four_transfer');
                
            }
            // var box_four= document.querySelector(".gens_content_img");
            // if($(window).scrollTop() > (box_four.offsetTop - box_four.offsetHeight)){
            //     $('.gens_content_img').addClass('opacity');
            // }
            var box_five= document.querySelector(".science_top");
            if( box_five!=null&&($(window).scrollTop()) > (box_five.offsetTop - box_five.offsetHeight)){
                $('#science_one').addClass('one_transfer');
                $('#science_two').addClass('two_transfer');
                $('#science_three').addClass('three_transfer');
                $('#science_four').addClass('four_transfer');

            }
            
            
        })
    },
    methods:{
        
    }
}
</script>

<style lang="scss" scoped>

  @import '../../assets/font/iconfont.css';
 @import '../../assets/css/animation.css';
.gens-cancerrealtime{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    

    .img-ss{
        position: relative;
        // display: flex;
        .gens-img{
            max-width: 100%;
            height: auto;
            position: relative;
        }
         .gens-title{
                   top:0;
                    width: 100%;
                    height: 100%;
                    font-size: 47px;
                    line-height: 60px;
                    color: #fff;
                    position: absolute;
                    display: flex;
                    justify-content: left;
                    align-items: center;
                    padding-left:10%;
                    padding-right:10%;
                    font-weight: 600;
            }
    }
    .gens_header_tip{
        background-color: #546c97;
        padding-top:30px;
        padding-bottom:30px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .tip_red{
            text-align: center;
            color: #f1c480;
            text-shadow: 1px 1px 2px #244b6b;
            font-size: 28px;
            font-style: normal;
            font-weight: 700;
            text-transform: none;
            line-height: 1.384615384615385em;
        }
        .tip_white{
            text-align: center;
            color: #ffffff;
            text-shadow: 1px 1px 2px #244b6b;
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            text-transform: none;
            margin-top:24px;
            line-height: 1.571428571428571em;
        }
    }

    .gens_result{
         background-color:#fff;
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
        
         .gens_result_info{
             width:1200px;
             margin:auto;
             .gens_result_info_tip{
                 .result_text{
                    color: #526e98;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .result_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #526e98;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }
                 .result_img_tip{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                    margin-block-start: 1em;
                    margin-block-end: 1em;
                    margin-inline-start: 0px;
                    margin-inline-end: 0px;             
                 }
                 .tip_img{
                         display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                        margin-bottom:30px;
                        .tip_img_s{
                            height: auto;
                            max-width: 100%;
                            width: 300px;
                        }
                 }
                 .tip_text_sk{
                     color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    margin-bottom:30px;
                 }
             }
            
            .gens_transparent_content_info{
                margin-bottom: 10px;
               
                .mytick{
                    color: #244b6b;;
                    background: 0 0;
                    border: 0;
                    font-size: 18px;
                    height: 16px;
                    width: 16px;
                    display: inline-block;
                    position: relative;
                    border:2px solid #244b6b;;
                }
                .mytick:before,.mytick:after {
                    content: '';
                    pointer-events: none;
                    position: absolute;
                    color: #244b6b;;
                    border: 2px solid #244b6b;;
                    background-color: white;
                }
                .mytick:before {
                    width: 1px;
                    height: 0px;
                    left: 18%;
                    top: 46%;
                    transform: skew(0deg, 50deg);
                }
                .mytick:after {
                    width: 11px;
                    height: 0px;
                    left: 38%;
                    top: 15%;
                    transform: skew(0deg, -50deg);
                }

                .tick_text{
                    line-height: 27px;
                    font-weight: 400;
                    margin: 0 0 0px;
                    padding: 0 0 0 18px;
                    position: relative;
                    color: #3a3a3a;
                    font-size: 16px;
                    margin-bottom: -12px;
                }
            }
             .gens_content_first{
                
                 display: flex;
                 justify-content: flex-start;
                 flex-direction: row;
                 margin-bottom:30px;
                 
                 .gens_content_first_left{
                        width:66.66%;
                        color: #3a3a3a;
                        font-size: 16px;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                        margin-bottom:30px;
                        margin-right: 30px;
                        div{
                            margin-bottom:30px;
                        }
                 }
                 .gens_content_first_right{
                     width:27.33%;
                     .gens_content_first_right_img{
                         opacity: 0;
                         margin-top:-60px;
                         display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                       
                         img{
                             height: auto;
                             max-width: 100%;
                             width:600px;
                         }
                     }
                     
                 }
             }

            .gens_result_info_imgs{
                // margin-bottom:30px;
                // display: inline-block;
                // vertical-align: top;
                // max-width: 100%;
                // img{
                //     vertical-align: middle;
                //     height: auto;
                //     max-width: 100%;
                // }
                display: flex;
                justify-content: flex-start;
                flex-direction: row;
                width:86%;
                .gens_result_info_left_img{
                    width:50%;
                    display: flex;
                    justify-content: flex-start;
                    flex-direction: column;
                    .info_left_img_item{
                        padding-bottom: 10px!important;
                        display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                        opacity:0;
                        img{
                            height: auto;
                            max-width: 100%;
                            width: 731px;
                        }
                    }
                    
                    
                }
                .gens_result_info_right_img{
                    width:50%;
                    display: flex;
                    justify-items: center;
                    text-align: center;
                    .info_right_img_info{
                        width:100%;
                        text-align: center;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: relative;
                        opacity: 0;
                            .right_imgs{
                                display: inline-block;
                                vertical-align: top;
                                max-width: 100%;
                                position: absolute;
                            img{
                                height: auto;
                                max-width: 100%;
                                vertical-align: middle;
                                width: 417px;
                            }
                        }
                    }
                    .four_transfer{
                         animation-duration: 2s !important;
                        -webkit-animation-duration:2s !important;
                        animation-fill-mode: both !important;
                        -webkit-animation-fill-mode: both !important;
                        transition-delay: 2s;
                        animation-delay: 2s;
                        animation: fadeInUpLeft  .7s 1 ease-in-out;
                    }
                }
                
            }

            .gens_result_science{
                  display:flex;
                  justify-content: left;
                  flex-direction: row;
                  padding-bottom:30px;
                  padding-top:30px;
                 .science_item{
                    width:25%;
                    text-align: left;
                    .science_item_img{
                        display: grid;
                        justify-content: center;
                        width: 100%;
                        position: relative;

                        -webkit-transition: opacity .8s ease 0s;
                        
                        transition-delay: .4s;
                        .img_science{
                            display: block;
                            margin: 0 0 15px ;
                            max-width: 100%;
                            height: auto;
                        }
                        .img_science_special{
                            width:150px !important;
                        }
                        
                    }
                    .science_item_img_one{
                        transition-delay: .2s;
                    }
                    .science_item_img_two{
                        transition-delay: .4s;
                    }
                    .science_item_img_three{
                        transition-delay: .6s;
                    }
                    .science_item_img_four{
                        transition-delay: .8s;
                    }

                    hr{
                            color: #9a9a9a;
                            display: block;
                            unicode-bidi: isolate;
                            margin-block-start: 0.5em;
                            margin-block-end: 0.5em;
                            margin-inline-start: auto;
                            margin-inline-end: auto;
                            overflow: hidden;
                            border-style: inset;
                            border-width: 1px;
                            border-top: 1px solid #9a9a9a !important;
                        }
                    .science_tip{
                        color: #ef682f;
                        font-size: 24px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 1.304347826086957em;
                        text-transform: none;
                        letter-spacing: 1px;
                        margin-inline-start: 0px;
                        margin-inline-end: 0px;
                    }
                    .science_abstract{
                         margin: 5px 0px 6px 0px;
                        .abstract_tip{
                            color:#244b6b;
                            font-size:18px;
                            font-style: normal;
                            font-weight: 600;
                            text-transform: none;
                            letter-spacing: 1px;
                        }
                        .abstract_tip_special{
                            font-size:24px !important;
                            text-align: center;;
                        }
                        .ab_special{
                            text-align: center;
                        }
                        .abstract_line{

                        }
                        .abstract_content_one{
                            ul{
                                margin-left:10px;
                                line-height: 27px;
                                letter-spacing: .07em!important;
                                color: #3b3b3b;
                                font-weight: 400;
                                font-size: 16px;
                                padding-inline-start: 0px !important;
                            }
                        }
                        .number{
                            font-size: .5em;
                            vertical-align: super;
                        }
                        .abstract_content{
                            color: #3a3a3a;
                            font-size: 16px;
                            line-height: 24px;
                            font-style: normal;
                            font-weight: 400;
                            letter-spacing: .07em!important;
                            margin-top: 24px;
                        }
                    }

                 }
                 #science_one,#science_two,#science_three,#science_four{
                     opacity: 0 ;
                 }
                 .science_item_special{
                    padding-left: 25px;
                    padding-right: 25px;
                }
                .science_item_special_std{
                    width:25% !important;
                    .img_science_specials{
                            width:130px !important;
                    }
                }
             }

             .gens_result_science_special{
                
             }
             

        }

         .gens_list{

             display:flex;
             width:1200px;
             margin:auto;
             justify-content: space-between;
             text-align: left;
             flex-direction: row;
             flex-wrap: wrap;
             margin-bottom:30px;
             .gens_list_item{
                 width:23%;
                 display: flex;
                 flex-direction: column;
                 .gens_list_item_single{
                     display:flex;
                     flex-direction: row;
                     margin-bottom:18px;
                    .gens_list_item_img{
                        display: inline-block;
                        position: relative;
                        z-index: 2;
                        img{
                            height: auto;
                            width:52px;
                        }
                    }
                    .gens_list_item_content{
                        padding: 0 0 0 20px;
                        .gens_list_item_tip{
                            color:#526e98;
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 600;
                            text-transform: none;
                            line-height: 1.571428571428571em;
                                                    
                            letter-spacing: 1px;
                        }
                        .gens_list_item_abstract{
                            font-size: 14px;
                            line-height: 24px;
                            color: #3a3a3a;
                            font-style: normal;
                            font-weight: 400;
                        }
                    }
                 }
             }
         }
         
    }
    .science_top{

    }

    .gens_result_people{
        background-color: rgba(207,213,227,0.2) !important;
    }
    .people_tops{

    }
    .gens_three_img{
            padding-top: 60px!important;
            padding-bottom: 60px!important;
            padding-left: 0!important;
            background-image: url(../../assets/images/cancerrealtime/cancer_icon-37.png)!important;
            position: relative;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: cover;
            .gens_three_img_content{
                width:1200px;
                margin:auto;
                text-align: left;
                .gens_three_img_content_d{
                    width:60%;
                    .gens_three_img_content_tip{
                        color:#526e98;
                        font-size: 28px;
                        font-style: normal;
                        font-weight: 700;
                        text-transform: none;
                        line-height: 1.384615384615385em;
                        letter-spacing: 1px;
                        margin-bottom:30px;
                    }
                    .three_imgs{
                        display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                        margin-bottom:30px;
                        img{
                            height: auto;
                            max-width: 100%;
                            
                        }
                    }
                }
        }
    }
   
    .gens_result_second{
         background-color: rgba(192,227,221,0.2);
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
        
         .gens_result_second_info{
             width:1200px;
             margin:auto;
             .gens_result_second_info_tip{
                 .gens_result_second_text{
                    color: #5ec3b5;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .gens_result_second_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #5ec3b5;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }
                 .gens_result_second_img_tip{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                    margin-block-start: 1em;
                    margin-block-end: 1em;
                    margin-inline-start: 0px;
                    margin-inline-end: 0px;             
                 }
               
             }

             .gens_result_second_content{
                 text-align: center;
                 .content_info{
                     display:flex;
                     justify-content: center;
                     align-items: center;
                     flex-direction: column;
                     .content_info_item{
                         width:1200px;
                         display: flex;
                         justify-content: center;
                         flex-direction: row;
                         .text_left{
                             padding:0 60px;
                             width:50%;
                             .text_left_tip{
                                color: #15867d;
                                font-size: 24px;
                                font-style: normal;
                                font-weight: 600;
                                text-transform: none;
                                line-height: 1.304347826086957em;
                                letter-spacing: 1px;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;
                                text-align: right;
                             }
                             .text_left_content{
                                color: #3a3a3a;
                                font-size: 16px;
                                line-height: 24px;
                                font-style: normal;
                                font-weight: 400;
                                opacity: 0;
                                transition: opacity .5s cubic-bezier(.22,.61,.36,1) .2s;
                                margin-top: 25px;
                                text-align: right;
                                display: block;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;

                        
                             }
                         }
                         .line_down{
                             display:flex;
                             flex-direction: column;
                             justify-content: center;
                             width: 20px;
                             padding-top:60px;
                             position: relative;
                             .circle{
                                 position:absolute;
                                background: #fff;
                                background-color: #5ec3b5;
                                box-sizing: border-box;
                                border: 1px solid transparent;
                                border-radius: 50%;
                                content: "";
                                height: 18px;
                                left: 50%;
                                margin: 0 0 0 -9px;
                                position: absolute;
                                top:20px;
                                width: 18px;
                                transform: scale(1);
                                transition: transform .6s cubic-bezier(.18,.89,.32,1.68) .5s;

                             }
                             .vertical{
                                background-color: #5ec3b5;
                                height: 100%;
                                left: 50%;
                                margin-left: -1px;
                                position: absolute;
                                width: 2px;
                             }
                         }
                         .img_right{
                             width:50%;
                             margin-left:-10px;
                             display:flex;
                             align-items: center;
                             padding-top:20px;
                             .img_img_right{
                                opacity: 0;
                                transform: scale(1);
                                transition: transform .6s cubic-bezier(.18,.89,.32,1.28) , opacity .3s ease-out;
                                text-align: left;
                                box-sizing: border-box;
                                img{
                                    max-width: 100%;
                                    height: auto;
                                    width: 1522px;
                                }
                             }
                             
                         }
                         .img_left{
                             width:50%;
                             margin-left:10px;
                             display:flex;
                             align-items: center;
                             padding-top:20px;
                             .img_img_left{
                                opacity: 0;
                                transform: scale(1);
                                transition: transform .6s cubic-bezier(.18,.89,.32,1.28) , opacity .3s ease-out;
                                text-align: right;
                                box-sizing: border-box;
                                margin-right:-10px;
                                img{
                                    max-width: 100%;
                                    height: auto;
                                    width: 1522px;
                                }
                             }
                         }
                           .text_right{
                             width:50%;
                             text-align: left;
                             padding:0 0px;
                             .text_right_tip{
                                color: #15867d;
                                font-size: 24px;
                                font-style: normal;
                                font-weight: 600;
                                text-transform: none;
                                line-height: 1.304347826086957em;
                                letter-spacing: 1px;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;
                                text-align: left;
                                padding-left:60px;
                             }
                            .text_right_content{
                                width:100%;
                                padding-left:60px;
                                color: #3a3a3a;
                                font-size: 16px;
                                line-height: 24px;
                                font-style: normal;
                                font-weight: 400;
                                opacity: 0;
                                transition: opacity .5s cubic-bezier(.22,.61,.36,1) .2s;
                                margin-top: 25px;
                                text-align: left;
                                display: block;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;

                        
                             }
                         }

                     }
                 }
             }
        }
    }
    

    .gens_advice{
         background-color:#fff;
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
         
        .gens_content{
            width:1200px;
            margin:auto;
            display: flex;
            justify-content: left;
            flex-direction: row;

            .gens_content_left{
                width:66.66%;
                padding-right:15px;
                .left_tips{
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    color: #5ec3b5;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                    margin-bottom:24px;

                }
                .left_advice_content{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
            }
            .gens_content_right{
                width:33.33%;
                display: inline-block;
                vertical-align: top;
                max-width: 100%;
                .gens_content_img{
                    animation: element-from-right .7s 1 ease-in-out;
                    opacity: 0;
                    img{
                        height: auto;
                        max-width: 100%;
                    }
                }
            }
        }
    }
    
    .gens_last_bottom{
        // background-image: url(../../assets/images/vaccinetest/antibody-report.jpg);
        // background-position: 50% 111px;
        position: static;
        padding: 0;
        background-repeat: no-repeat;
        background-color: transparent;
        background-position: center 0;
        background-attachment: fixed;
        overflow: hidden;
        .gens_last_bottom_content{
            width:1200px;
            margin:auto;
            text-align: left;

            .gens_last_bottom_content_tip{
               color: #526e98;
               font-size: 28px;
               font-style: normal;
               font-weight: 700;
               text-transform: none;
               line-height: 1.384615384615385em;
               letter-spacing: 1px;
               margin-top:60px;
            }
            .gens_last_bottom_content_tip_line{
                margin-top: 10px;
                margin-bottom: 30px;
                background-color: #526e98;
                width: 250px;
                height: 2px;
                position: relative;

            }
            .gens_last_bottom_content_descript{
                display:flex;
                flex-direction: row;
                border-left:4px solid #526e98;
                background-color: rgba(207,213,227,0.2);
                
                padding-bottom:24px;
                margin-bottom:30px;
                padding-top:14px;
                .yinhao{
                    color: #526e98;
                    font-size: 38px;
                    margin: 6px 0 0 12px!important;
                    display: inline-block;
                    font: normal normal normal 14px/1 FontAwesome;
                    letter-spacing: 0.07em !important;
                }
                .contents{
                    margin-left:40px;
                   .contents_tip{
                        color: #244b6b;
                        font-size: 21px;
                        line-height: 32px;
                        letter-spacing: 0px;
                        text-transform: none;
                        font-style: normal;
                        font-weight: 300;

                   }
                   .contents_cont{
                       color: #3a3a3a;
                        font-size: 16px;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                   }
                }
            }

            .bottom_document_tip{
                font-size: 12px;
                color: #3a3a3a;
                line-height: 24px;
                font-style: normal;
                font-weight: 400;
                letter-spacing: 0.07em !important;
            }
            .bottom_document_cont{
                font-size: 12px;
                color: #3a3a3a;
                line-height: 24px;
                font-style: normal;
                font-weight: 400;
                letter-spacing: 0.07em !important;
                
            }
            .bottom_document_cont_last{
                margin-bottom:60px;
            }
            
            
        }
    }


.opacity{
    opacity: 1 !important;
}

.special_result{
   background-color: rgba(207,213,227,0.2);
  
}
    

}
</style>

<style lang="scss">

.gens_results_right{
    .el-carousel__button{
        border-radius: 50% !important;
        width:12px !important;
        height: 12px !important;
    }
}
@-o-keyframes element-from-bottom{
    0%{-o-transform:translate(0,30%);opacity:0}
    100%{-o-transform:translate(0,0);opacity:1}
}
@-o-keyframes element-from-left{
    0%{
        -o-transform:translate(-20%,0);opacity:0}
    100%{
        -o-transform:translate(0,0);opacity:1}
}
</style>


// WEBPACK FOOTER //
// src/view/genedetection/cancerrealtime.vue